// extracted by mini-css-extract-plugin
module.exports = {"optionContent":"src-components-flowable-FlowablePersonSearch-components-ExpandOption-styles___optionContent"};